/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Ares_Not_FoundInputs */

const cs_auth_signup_ares_not_found = /** @type {(inputs: Auth_Signup_Ares_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO v ARES nenalezeno`)
};

const en_auth_signup_ares_not_found = /** @type {(inputs: Auth_Signup_Ares_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO not found in ARES`)
};

/**
* | output |
* | --- |
* | "IČO not found in ARES" |
*
* @param {Auth_Signup_Ares_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_ares_not_found = /** @type {((inputs?: Auth_Signup_Ares_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Ares_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_ares_not_found(inputs)
	return cs_auth_signup_ares_not_found(inputs)
});